
export class TextFormatter
{
    static NicePhoneNumber(input: string): string
    {
        // Usuń wszystkie znaki poza cyframi i +
        const cleaned = input.replace(/[^\d+]/g, "");

        // Sprawdź, czy numer zaczyna się od "+"
        const hasPlus = cleaned.startsWith("+");

        // Usuń plusa, żeby łatwiej operować na cyfrach
        const digits = hasPlus ? cleaned.slice(1) : cleaned;

        if (digits.length === 9)
        {
            // Format krajowy: 000-000-000
            return digits.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3");
        }
        // else if (digits.length > 9)
        // {
        //     // Format z kierunkowym: +00 000-000-000
        //     const countryCode = digits.slice(0, digits.length - 9);
        //     const numberPart = digits.slice(-9);
        //     const formattedNumber = numberPart.replace(
        //         /(\d{3})(\d{3})(\d{3})/,
        //         "$1-$2-$3"
        //     );
        //     return `+${countryCode} ${formattedNumber}`;
        // }

        // Jeśli nie pasuje, zwróć w oryginalnej postaci
        return input;
    }
}
